import React from "react";
import { FaRegStar, FaStar } from "react-icons/fa";

interface ReviewStarsProps {
  stars: string;
  size?: number;
}

const ReviewStars: React.FC<ReviewStarsProps> = ({ stars, size = 17 }) => {
  const starCount = parseInt(stars, 10);

  if (isNaN(starCount) || starCount < 0) {
    return null;
  }

  const starIcons = [];
  for (let i = 0; i < 5; i++) {
    if (i < starCount) {
      starIcons.push(<FaStar key={i} color="#FFD700" size={size} />);
    } else {
      starIcons.push(<FaRegStar key={i} color="#FFD700" size={size} />);
    }
  }

  return <div style={{ display: "flex" }}>{starIcons}</div>;
};

export default ReviewStars;
